export function calcPercentageLatePayments(
  // The number of payments made regardless whether it's on time or late.
  numPayments: number,
  // The number of payments made late.
  numPaymentsLate: number
): string {
  // Handling non-numbers/non-finite payments
  if (
    Number.isNaN(numPayments) ||
    !Number.isFinite(numPayments) ||
    typeof numPayments !== 'number'
  )
    return '';

  // Handling a non-positive integer number of payments
  if (numPayments < 1) return '0%';

  const noDecimalPercentageValue = Math.trunc(
    (numPaymentsLate / numPayments) * 100
  );
  return `${noDecimalPercentageValue}%`;
}
